import {useForm} from 'react-hook-form';
import {Trans} from '@common/i18n/trans';
import { useEffect, useState } from 'react';
import { ProgressCircle } from '@common/ui/progress/progress-circle';
import { RateSheetSettingsWithValues, useUpdateRateSheetSettings } from '@app_modules/requests/update-rate-sheet-settings';
import { AnalysisRateSheetForm } from './analysis-rate-sheet-form';
import { AnalysisRateSheetLayout } from './analysis-rate-sheet-layout';
// import { AnalysisRateSheetForm } from '../analysis-rate-sheet-form';

export function AnalysisRateSheetPage({id, items, marketRateDate, timeChange, loan_program_types}: any) {
  if (items.length) {
    return (
      <>
      <AnalysisRateSheetUploading id={id} market_rate_date={marketRateDate} data_items={items} timeChange={timeChange} loan_program_types={loan_program_types}/>
      </>
    );
  } else {
    return (<ProgressCircle isIndeterminate aria-label="Loading settings..." />);
  }
}

export function AnalysisRateSheetUploading({id, market_rate_date, data_items, timeChange, loan_program_types}:{id: number, market_rate_date: string, data_items: any, timeChange: any, loan_program_types: any}) {

  const [defaultValues, setDefaultValues] = useState<any>({});
  

  const form = useForm<RateSheetSettingsWithValues>({
    defaultValues: defaultValues,
  });

  useEffect(() => {
    if (data_items) {
      const newDefaultValues: { [key: string]: string } = {};
      data_items.forEach((item: any, pindex: number) => {
        if (item.subItems && item.subItems.length > 0) {
          item.subItems.forEach((subItem: any, index: number) => {
            newDefaultValues[`${pindex}_${index}_loan_program_type`] = subItem.loan_program_type;
            newDefaultValues[`${pindex}_${index}_investor_code`] = subItem.investor_code;
            newDefaultValues[`${pindex}_${index}_sheet_name`] = subItem.sheet_name;
            newDefaultValues[`${pindex}_${index}_description`] = subItem.description;
            newDefaultValues[`${pindex}_${index}_analysis_prompt`] = subItem.analysis_prompt;
          });
        }
      });
      // Update state and reset form with new values
      setDefaultValues(newDefaultValues);
      form.reset(newDefaultValues); // Reset form with updated values
    }
  }, [data_items, timeChange, form]);

  return (
    <AnalysisRateSheetLayout
      form={form}
    >
      <AnalysisRateSheetForm id={id} market_rate_date={market_rate_date} data_items={data_items} timeChange={timeChange} loan_program_types={loan_program_types}/>
    </AnalysisRateSheetLayout>
  );
  
}


  
